import { utils } from '@ps/poker-games-tile-mappers';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import LaurelIcon from '../../../../../../assets/icons/laurel.svg';

import { TXTCLI_Entry } from './WinnerItem.messages.json';
import styles from './WinnerItem.scss';

interface WinnerItemProps {
  classes?: {
    root?: string;
    details?: string;
    username?: string;
    award?: string;
  };
  prizePoolUnit: number;
  winner: string;
  winnerAward?: string;
}

const WinnerItem: React.FC<WinnerItemProps> = ({
  classes = { root: '', details: '', username: '', award: '' },
  prizePoolUnit,
  winner,
  winnerAward
}) => {
  const isPrizeRealMoney = utils.mttUtils.isPrizePoolRealMoney(prizePoolUnit);

  return (
    <div className={classNames(styles.winnerItem, classes.root)}>
      <LaurelIcon />
      <div className={classNames(styles.details, classes.details)}>
        <p className={classNames(styles.username, classes.username)}>{winner}</p>
        <p className={classNames(styles.award, classes.award)}>
          {isPrizeRealMoney && winnerAward}
          {!isPrizeRealMoney && <Translation {...TXTCLI_Entry} />}
        </p>
      </div>
      <LaurelIcon className={styles.reversed} />
    </div>
  );
};

export default WinnerItem;
